import { ProgramMembership } from 'types/Membership';

export const hasMultipleProgramMemberships = (programMemberships: Array<Pick<ProgramMembership, 'programId'>>) =>
	new Set(programMemberships.map(({ programId }) => programId)).size > 1;
